import { createUseStyles } from 'react-jss'

import { COLOR, MQ, Z_INDEX } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    minHeight: 600,
    [MQ.TABLET]: {
      justifyContent: 'flex-end',
    },
    [MQ.DESKTOP]: {
      justifyContent: 'flex-start',
    },
  },
  image: {
    width: '100%',
    minHeight: 600,
    filter: 'brightness(95%)',
  },
  textBlock: {
    position: 'absolute',
    textAlign: 'left',
    zIndex: Z_INDEX.CONTENT,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: [0, 15, 100, 35],
    maxWidth: 350,
    width: '80%',
    left: 0,
    [MQ.TABLET]: {
      maxWidth: 550,
      width: '80%',
      padding: [0, 20, 100, 90],
    },
    [MQ.TABLET_LARGE]: {
      maxWidth: 600,
      padding: [0, 40, 100, 100],
    },
    [MQ.DESKTOP]: {
      maxWidth: 525,
      width: '50%',
      padding: 0,
      margin: [0, 0, 100, '14%'],
    },
  },
  title: {
    padding: [0, 0, 32],
    color: COLOR.WHITE,
    [MQ.TABLET]: {
      maxWidth: 545,
      padding: [0, 0, 20],
    },
    [MQ.DESKTOP]: {
      maxWidth: 650,
    },
  },
  subTitle: {
    maxWidth: 500,
    padding: [0, 0, 15],
    color: COLOR.WHITE,
    [MQ.TABLET]: {
      padding: [0, 0, 10],
    },
    [MQ.DESKTOP]: {
      padding: [0, 0, 20],
    },
  },
  buttonWrapper: {
    marginTop: 20,
  },

  imageOverlay: {
    // backgroundColor: 'rgb(32, 32, 32, 0.5)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: Z_INDEX.BACKGROUND,
  },
  navy: {
    color: COLOR.DARK_GREEN,
  },
  blue: {
    color: COLOR.LIGHT_GREEN,
  },
})
